import { render } from "./VideoControllerSetting.vue?vue&type=template&id=7cc7c9b3&scoped=true"
import script from "./VideoControllerSetting.vue?vue&type=script&lang=js"
export * from "./VideoControllerSetting.vue?vue&type=script&lang=js"

import "./VideoControllerSetting.vue?vue&type=style&index=0&id=7cc7c9b3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc7c9b3"]])

export default __exports__